import FormItem from "@components/formItem";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems.js";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems.js";
import { getUser } from "@utils";
import React from "react";
import MaskInput from "react-maskinput";
import PaymentSelect from "../../../../../components/paymentSelect/index.jsx";
import { Box, BoxTitle, Content, ContentTitle, MaskedInput, MaskedInputLabel } from "../baseItems";
import Base from "./base";

export default class Payturka extends Base {
	handleFocus = (field) => {
		this.setState({ [field]: true });
	};

	handleBlur = (field, value) => {
		const cleanedValue = value.replace(/_/g, "").trim();
		const isEmptyOrMasked = cleanedValue === "";
		this.setState({
			[field]: false,
			[`${field.replace("is", "").toLowerCase()}Value`]: isEmptyOrMasked ? "" : cleanedValue,
		});
	};

	onEnterValue = (field, e) => {
		const value = e.target.value.replace(/_/g, "").trim();
		this.setState({ [field]: value, [`${field}Value`]: value });
	};

	onSelectPaymentCode(e) {
		this.setState(
			{
				paymentCode: e.label,
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	getStep1(translate) {
		const { stake, selectedCurrency, paymentCode, isWalletMaskVisible, account, accountValue } =
			this.state;
		const options = [
			{ value: 0, label: translate("PLEASE_SELECT") },
			{ value: 1, label: "qr" },
			{ value: 2, label: "cmt" },
		];
		let selectedPayCode = paymentCode ? options.find((o) => o.label === paymentCode).value : 0;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				<BoxWrapper>
					<FormItem onRegister={() => this.registerField({ name: "paymentCode" })}>
						<Box>
							<BoxTitle>{translate("SELECT_PAYMENT_CODE")}</BoxTitle>
							<PaymentSelect
								options={options}
								value={selectedPayCode}
								handleSelect={this.onSelectPaymentCode.bind(this)}
							/>
						</Box>
					</FormItem>
					<FormItem onRegister={() => this.registerField({ name: "account" })}>
						<Box>
							<MaskedInput>
								<MaskInput
									ref={this.walletInputRef}
									alwaysShowMask={window.IS_MARS ? true : false}
									onFocus={() => this.handleFocus("isWalletMaskVisible")}
									onBlur={(e) =>
										this.handleBlur("isWalletMaskVisible", e.target.value)
									}
									maskChar={isWalletMaskVisible ? "_" : ""}
									mask="* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * "
									size={42}
									onChange={(e) => this.onEnterValue("account", e)}
									value={isWalletMaskVisible ? account : accountValue}
								/>
								<MaskedInputLabel
									isFocused={isWalletMaskVisible}
									hasValue={accountValue}>
									{translate("WALLET_ADDRESS")}
								</MaskedInputLabel>
							</MaskedInput>
						</Box>
					</FormItem>
				</BoxWrapper>
			</Content>
		);
	}

	makeExternalPayment() {
		const { stake, accountValue, paymentCode, selectedCurrency } = this.state;
		let withdrawData = {
			type: "Payturka",
			username: getUser().username,
			amount: {
				value: stake,
				currency: selectedCurrency ? selectedCurrency : "TRY",
			},
			remoteId: accountValue,
			language: this.getActiveLanguageCode(),
			paymentCode: paymentCode,
			note: new Date(),
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}
}
